<div class="spinner-container">
  @if (show) {
  <div [ngClass]="btnClasses" class="button-spinner-container btn btn-primary">
    <div class="spinner"></div>
  </div>
  }
  <ng-content></ng-content>
</div>
